import styled from 'styled-components';

export const SearchIcon = styled.img`
    position: absolute;
    width: 1rem;
    height: 1rem;
    top: ${(props) => props.top};
    left: ${(props) => props.left};
`;
